import React, { useEffect, useState } from 'react'
import { clientRoutes } from '../routes/index'
import { Header, Content, Footer } from './index'
import Sidebar from 'src/components/Sidebar'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { clientData } from 'src/store/actions/clientActions'
import { getRedirectUrl } from 'src/lib/utils'
function ClientLayout() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation().pathname.split('/')
  const language = useSelector((state) => state.language)
  const token = window.sessionStorage.getItem('token')
  const role = window.sessionStorage.getItem('role')
  const path = location[2]
  const [isSidebar, setIsSidebar] = useState(false)
  const securedRoutes = ['conclusion', 'submitintake', 'submittedintakes', 'reviewsaymorequestions']
  useEffect(() => {
    if (['intake', 'facesheet', 'presection', 'messages'].includes(path)) {
      setIsSidebar(true)
    } else {
      setIsSidebar(false)
    }
  }, [path])
  useEffect(() => {
    if (!token) {
      navigate('/login', { replace: true })
    } else if (role === 'A') {
      navigate('/login', { replace: true, state: { isCurrent: 'attorney' } })
    } else if (role === 'N') {
      navigate('/login', { replace: true, state: { isCurrent: 'admin' } })
    } else if (role === 'C') {
      dispatch(clientData(language))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, role, language])
  useEffect(() => {
    const url = getRedirectUrl()
    const token = window.sessionStorage.getItem('token')
    if (!token) navigate('/login', { replace: true })
    else if (
      (securedRoutes.includes(location.pop()) || securedRoutes.includes(path)) &&
      url !== 'conclusion'
    )
      navigate(`/client/${url}`)
  }, [path])
  const isHide = ['securedreport', 'report'].includes(path)
  return (
    <div className="d-flex flex-column vh-100">
      {!isHide && <Header />}
      {isSidebar && <Sidebar />}
      <Content routes={clientRoutes} />
      {!isHide && <Footer />}
    </div>
  )
}

export default ClientLayout
